import React, { Component } from 'react';
import { Input, Button, Form, Icon, notification } from 'antd';
import axios from 'axios';
import api from '@root/utils/api';
import cookies from 'js-cookie';
import auth from '@root/service/auth-manager';
// import commonStore from '@root/stores/commonStore'
import zhuyunLogin from '@root/service/zhuyunLogin';
import {
  Encrypt,
  //  Decrypt,
  randomStr,
  rsaEncrpt,
} from '@root/utils/utils';
import './login.scss';
import { _CITY_ } from 'udian-tob-lib';
// import md5 from 'md5';

const logo =
  _CITY_.city === 'shenzhen'
    ? require('@root/assets/images/logo.png')
    : require('@root/assets/tengxian/logo.png');

// const FormItem = Form.Item;

const pageStyle = {
  backgroundImage:
    _CITY_.city === 'shenzhen'
      ? 'url(' + require('@root/assets/images/login_bg.png') + ')'
      : 'url(' + require('@root/assets/tengxian/login_bg.png') + ')',
};

export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
      errMsg: '',
      loading: false,
      isKeepName: true,
      user: cookies.get('userName') || '',
      password: '',
      verify: '',
      verifyCode: '',
      isShowVerify: false,
      isShowMessage: false,
      messageText: '发送验证码',
      messageTime: 60,
      isSendMessage: false,
      messageInput: '',
      messageLoading: false,
    };
    this.user = '';
    this.password = '';
    this.timer = null;
    // 跳转来源系统code
    this.fromSysClientId = '';
    this.szbusApiUrl = '';
    this.fromSysUrl = '';
    this.udCode = '';
  }

  async componentWillMount() {
    const cdomain = window.location.host.match(/(.[^.]*)\.(.[^:]*)(:.*)?/)[2];
    const _domain = cookies.get('domain');

    // 数据初始化
    if (_CITY_.city === 'shenzhen') {
      zhuyunLogin.pageInit();
    }

    if (auth.isReportSkip) {
      this._goto();
    }

    // _domain 为空时不跳转
    if (_domain && cdomain !== _domain) {
      auth.toLoginPage();
      return;
    }

    // 三级域名校验token是否相同
    // if (
    //   _domain.split('.').length > 2 &&
    //   localStorage.getItem('token') &&
    //   localStorage.getItem('token') !== cookies.get('token')
    // ) {
    //   return;
    // }

    if (auth._userInfo) {
      this._goto();
    }

    // 获取所有url参数对象
    const query = new URLSearchParams(window.location.search);
    // 跳转来源系统code
    this.udCode = query.get('udcode') || '';
    // 开发环境和qa环境不跳转来源系统code
    if (process.env.BUILD_TO === 'dev-maas' || process.env.BUILD_TO === 'qa-maas') {
      this.udCode = true;
    }
  }

  componentDidMount() {
    document.addEventListener('keydown', this._keyEvent);
    if (this.state.isShowVerify) {
      this.getVerifyCode();
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this._keyEvent);
  }

  getVerifyCode = () => {
    const { user } = this.state;
    let serveBase = axios.create({
      responseType: 'arraybuffer',
      headers: {
        access_token: cookies.get('token'),
        token: cookies.get('token'),
      },
    });
    serveBase
      .post(api.common.getVerifyCode, {
        account: user,
      })
      .then((res) => {
        // 通过流长度判断是否返回正确的图片流
        if (res.data && res.data.byteLength < 100) {
          return;
        }
        const verifyCode =
          'data:image/png;base64,' +
          btoa(
            new Uint8Array(res.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
          );
        this.setState({
          verifyCode,
          isShowVerify: true,
        });
      });
  };

  _keyEvent = (event) => {
    var e = event || window.event;
    if (e && e.keyCode === 13) {
      this.handleOk();
    }
  };

  handleOk = () => {
    let errMsg = '';
    const { user, password, verify, isShowVerify, messageInput, isShowMessage } = this.state;
    if (isShowVerify && !verify) errMsg = '请输入验证码！';
    if (isShowMessage && !messageInput) errMsg = '请输入短信验证码！';
    if (!user || !password) errMsg = '请输入账号或者密码！';

    if (errMsg) {
      this.setState({
        errMsg,
      });
      return;
    }

    if (this.state.isKeepName) {
      cookies.set('userName', user);
    } else {
      cookies.remove('userName');
    }
    this.setState({ loading: true });
    // const pwd = md5(md5(md5(password)));
    const rStr = randomStr(),
      rsaStr = rsaEncrpt(rStr);
    const pwd = Encrypt(password, rStr);
    // const decPwd = Decrypt(pwd, rStr);
    // console.log('--随机值---', rStr, '---公钥加密key---', rsaStr, '---加密后的密码---', pwd);

    const params = {
      phone: user,
      password: pwd,
      identityKey: rsaStr,
      udCode: this.udCode,
    };
    if (verify) {
      params.imageVerifyCode = verify;
    }
    if (messageInput) {
      params.phoneVerifyCode = messageInput;
    }

    axios
      .post(api.common.login, params)
      .then((res) => {
        auth.loginSuccess(res.data.data);
        this.setState({ loading: false });
        this._goto();
      })
      .catch((err) => {
        if (err) {
          err.cancelAlert();
          errMsg = err.data.msg;
        }
        // console.log('=========', err.data);
        // 异地登录
        if (err.data.code === 99999) {
          this.setState({
            errMsg,
            loading: false,
            isShowMessage: true,
          });
          return;
        }
        // 手机短信验证错误
        if (err.data.code === 100) {
          this.setState({
            errMsg,
            loading: false,
            messageTime: 60,
            isShowMessage: true,
            isSendMessage: false,
            messageText: '重新发送验证码',
          });
          return;
        }
        // 其他登录错误
        this.getVerifyCode();
        this.setState({
          errMsg,
          loading: false,
        });
      });
  };

  // 发送短信验证码
  sendMessage = () => {
    const { user } = this.state;
    this.setState({
      messageLoading: true,
    });
    axios
      .post(api.common.senMessageCode, {
        account: user,
        smsType: 1,
      })
      .then((res) => {
        this.setState(
          {
            isSendMessage: true,
            messageLoading: false,
          },
          () => {
            let { messageTime } = this.state;
            this.timer && clearInterval(this.timer);
            this.timer = setInterval(() => {
              if (messageTime <= 0) {
                clearInterval(this.timer);
                this.setState({
                  messageTime: 60,
                  isSendMessage: false,
                  messageText: '重新发送验证码',
                });
                return;
              }
              this.setState({
                messageTime: messageTime--,
              });
            }, 1000);
          }
        );
        notification.success(res.data.data);
      })
      .catch((err) => {
        this.timer && clearInterval(this.timer);
        this.setState({
          messageTime: 60,
          isSendMessage: false,
          messageLoading: false,
          messageText: '重新发送验证码',
        });
      });
  };

  async _goto() {
    const curHref = window.location.href;
    if (curHref.indexOf('goto=') > -1) {
      let url = curHref.split('goto=')[1];
      // 对报表做特殊处理
      if (auth.isReportSkip) {
        url = url.replace('&', '?');
        const tokenId = url.split('token=')[1].replace('#', '');
        if (auth._userInfo && auth._userInfo.tokenId === tokenId) {
          return (window.location.href = url);
        }
        // 成功跳报表页面，失败回portal页
        let isSuccess = await auth.getUserByTokenId(tokenId);
        if (!isSuccess) return this.props.history.push('/portal');
      }
      // 从报表系统退出
      // if (curHref.indexOf('bigdata') && !cookies.get('tokenId')) {
      //   auth.toLoginPage();
      //   return;
      // }
      window.location.href = url;
    } else {
      this.props.history.replace('/portal');
    }
  }

  gotoSzBus = () => {
    zhuyunLogin.gotoSzBus();
  };

  render() {
    const {
      errMsg,
      loading,
      verifyCode,
      isShowVerify,
      isShowMessage,
      messageText,
      isSendMessage,
      messageTime,
      messageInput,
      messageLoading,
    } = this.state;

    return (
      <div className="login_page" style={pageStyle}>
        {auth.isReportSkip ? (
          <div className="login_page_loading">
            <Icon type="loading" />
            页面跳转中...
          </div>
        ) : (
          <div className="login_page_inner">
            <div className="login_box">
              <Form hideRequiredMark={true}>
                <div className="logo">
                  <img src={logo} alt="logo" />
                </div>
                <div className="login_form">
                  <Input
                    placeholder="用户名/手机号"
                    disabled={!this.udCode}
                    value={this.state.user}
                    autoComplete="off"
                    onChange={(e) => {
                      this.setState({
                        user: e.target.value,
                      });
                    }}
                  />
                  <ins className="udianfont udian-denglu-1 login_form_icon"></ins>
                </div>
                <div className="login_form">
                  <Input
                    type="password"
                    value={this.state.password}
                    placeholder="请输入密码"
                    disabled={!this.udCode}
                    autoComplete="off"
                    onChange={(e) => {
                      this.setState({
                        password: e.target.value,
                      });
                    }}
                  />
                  <ins className="login_form_icon udianfont udian-denglu-"></ins>
                </div>
                {/* <div className="login_keep_name">
                                        <Checkbox checked={this.state.isKeepName} onChange={e=>{
                                            this.setState({
                                                isKeepName: e.target.checked
                                            })
                                        }}>记住该用户名</Checkbox>
                                    </div> */}
                {isShowVerify ? (
                  <div className="verify_box">
                    <Input
                      className="verify_input"
                      value={this.state.verify}
                      placeholder="请输入验证码 (不区分大小写)"
                      onChange={(e) => {
                        this.setState({
                          verify: e.target.value,
                        });
                      }}
                    />
                    <img src={verifyCode} alt="" onClick={this.getVerifyCode} />
                  </div>
                ) : null}
                {isShowMessage ? (
                  <div className="verify_box message_verify_box">
                    <Input
                      className="verify_input"
                      value={messageInput}
                      placeholder="请输入短信验证码"
                      onChange={(e) => {
                        this.setState({
                          messageInput: e.target.value,
                        });
                      }}
                    />
                    {/* <img src={verifyCode} alt="" onClick={this.getVerifyCode} /> */}
                    <Button
                      className="message_verify_btn"
                      disabled={isSendMessage}
                      loading={messageLoading}
                      onClick={this.sendMessage}
                    >
                      {isSendMessage ? messageTime + 's' : messageText}
                    </Button>
                  </div>
                ) : null}
                <p className="warn_msg" id="warn__msg">
                  {errMsg ? <span className="warn_msg_text">{errMsg}</span> : null}
                  {/* <i className="udianfont udian-no_datas-"></i> */}
                </p>
                <Button
                  onClick={this.handleOk}
                  loading={loading}
                  className="login_form_btn"
                  id="loginBtn"
                  disabled={!this.udCode}
                >
                  登&nbsp;&nbsp;&nbsp;&nbsp;录
                </Button>
                {/* {_CITY_.city === 'shenzhen' ? (
                  <Button onClick={this.gotoSzBus} className="login_link_zhuyun">
                    统一平台登录
                  </Button>
                ) : null} */}
                <p className="forget_text">
                  忘记密码？联系管理员找回
                  <a href="mailto:dotransit@udiannet.com">dotransit@udiannet.com</a>
                </p>
              </Form>
            </div>
            <footer className="login_foot">
              {/* <span>滴滴优点科技(深圳)有限公司 Copyright © 2017 粤ICP备17071394号 </span> */}
              <div className="udian_footer_copy">
                滴滴优点科技（深圳）有限公司 Copyright&#169;2016-
                {new Date().getFullYear()}&nbsp;
                <a
                  href="https://beian.miit.gov.cn"
                  target="_blank"
                  style={{ color: '#908e9f' }}
                  rel="noopener noreferrer"
                >
                  粤ICP备17071394号-1
                </a>
              </div>
            </footer>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/view/Login/login.js